
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router: Router = inject(Router);
  const isAuthenticated = authService.isAuthenticated();
  
  console.log(`[LoginGuard] Checking route: ${state.url}. Is authenticated? ${isAuthenticated}`);

  if (authService.isAuthenticated()) {
    console.log(`[LoginGuard] User is already authenticated. Redirecting to /applications.`);
    return router.parseUrl('/applications');
  }

  console.log('[LoginGuard] User is not authenticated. Allowing access to login page.');
  return true;
};
